export const PRODUCT_NAME = 'EightBots';
export const PRODUCT_ENTRY_LABEL = 'Meet Eightbots';
